import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { adminApi } from '@/lib/adminApi';
import { type Renderer } from '@/lib/boardOutput';
import { AdminPage, RegistryTable, Pill, StatusPill } from '@/admin';

export function RenderersPage() {
  const q = useQuery({ queryKey: ['renderers'], queryFn: () => adminApi.renderers.list() });
  const [search, setSearch] = useState('');
  const rows = Object.values(q.data?.renderers ?? {});

  return (
    <AdminPage title="Renderers" description="The consumers of board_findings — each produces one artifact (an intervention-scoped renderer reads one class; a summary renderer reads the whole findings). Read-only (seed-authored).">
      {q.data ? <div className="mb-13 text-body-sm text-text-secondary">{rows.length} renderers · registry v{String(q.data.version ?? '?')}</div> : null}
      <RegistryTable<Renderer>
        columns={[
          { key: 'renderer_id', header: 'Renderer', className: 'font-mono text-[12px]', render: (r) => r.renderer_id },
          { key: 'scope', header: 'Scope', render: (r) => <Pill label={r.scope} color={r.scope === 'summary' ? '#5B72E8' : '#2BBAA8'} /> },
          { key: 'target', header: 'Reads', className: 'font-mono text-[11px] text-text-secondary', render: (r) => r.intervention_class || (r.consumes_intervention_classes === 'all' ? 'all classes' : 'findings') },
          { key: 'output', header: 'Output', className: 'text-[12px]', render: (r) => r.output_format || '—' },
          { key: 'audience', header: 'Audience', className: 'text-[12px] text-text-secondary', render: (r) => r.audience || '—' },
          { key: 'status', header: 'Status', render: (r) => <StatusPill on={r.active_default} label={r.active_default ? 'live' : 'scaffold'} /> },
          { key: 'description', header: 'Description', className: 'max-w-[340px] text-[12px] text-text-secondary', render: (r) => r.description || '—' },
        ]}
        rows={rows.filter((r) => !search || `${r.renderer_id} ${r.output_format} ${r.description}`.toLowerCase().includes(search.toLowerCase()))}
        getRowKey={(r) => r.renderer_id}
        count={rows.length}
        state={{ loading: q.isLoading, error: q.isError }}
        emptyText={search ? `No renderers match "${search}"` : 'No renderers.'}
        search={{ value: search, onChange: setSearch, placeholder: 'Search renderers…' }}
      />
    </AdminPage>
  );
}
